/**
 * Nolana theme — home page section behaviours.
 * Ported from tema-demo/assets/js/nolana.js: category panels (tap to open on mobile),
 * product row arrows ([data-row] with [data-row-prev] / [data-row-next]) and tabs
 * ([data-tabs] with [data-tab] / [data-tab-pane]).
 * Loaded by the sections that need it; guarded against Theme Editor double-binding.
 */
(function () {
  "use strict";

  if (document.documentElement.dataset.nolanaHomeReady) return;
  document.documentElement.dataset.nolanaHomeReady = "true";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var mobile = window.matchMedia("(max-width: 900px)");

  /* ---------- Category panels: first tap opens on mobile, second tap follows the link ---------- */
  document.addEventListener("click", function (event) {
    var panel = event.target.closest("[data-panel]");
    if (!panel || !mobile.matches) return;
    if (panel.classList.contains("is-open")) return;
    event.preventDefault();
    document.querySelectorAll("[data-panel].is-open").forEach(function (open) {
      open.classList.remove("is-open");
    });
    panel.classList.add("is-open");
  });

  /* ---------- Product row arrows ---------- */
  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-row-prev], [data-row-next]");
    if (!button) return;
    var shell = button.closest("[data-row]");
    var row = shell ? shell.querySelector(".p-row") : null;
    if (!row) return;
    var direction = button.hasAttribute("data-row-next") ? 1 : -1;
    row.scrollBy({ left: direction * row.clientWidth * 0.8, behavior: reduceMotion ? "auto" : "smooth" });
  });

  /* ---------- Tabs ---------- */
  function activateTab(tabs, tab) {
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll("[data-tab]"));
    var panes = Array.prototype.slice.call(tabs.querySelectorAll("[data-tab-pane]"));
    var target = tab.getAttribute("data-tab");
    buttons.forEach(function (button) {
      var active = button === tab;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-selected", active ? "true" : "false");
      button.setAttribute("tabindex", active ? "0" : "-1");
    });
    panes.forEach(function (pane) {
      var active = pane.getAttribute("data-tab-pane") === target;
      pane.classList.toggle("is-active", active);
      pane.hidden = !active;
    });
    if (window.Nolana && typeof window.Nolana.initReveal === "function") window.Nolana.initReveal(tabs);
  }

  document.addEventListener("click", function (event) {
    var tab = event.target.closest("[data-tab]");
    if (!tab) return;
    var tabs = tab.closest("[data-tabs]");
    if (!tabs) return;
    event.preventDefault();
    activateTab(tabs, tab);
  });

  document.addEventListener("keydown", function (event) {
    var tab = event.target.closest ? event.target.closest("[data-tab]") : null;
    if (!tab || (event.key !== "ArrowRight" && event.key !== "ArrowLeft")) return;
    var tabs = tab.closest("[data-tabs]");
    if (!tabs) return;
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll("[data-tab]"));
    var index = buttons.indexOf(tab);
    var next = buttons[(index + (event.key === "ArrowRight" ? 1 : -1) + buttons.length) % buttons.length];
    event.preventDefault();
    activateTab(tabs, next);
    next.focus();
  });

  /* Theme Editor: selecting a tab block shows its pane. */
  document.addEventListener("shopify:block:select", function (event) {
    var pane = event.target.closest ? event.target.closest("[data-tab-pane]") : null;
    if (!pane) return;
    var tabs = pane.closest("[data-tabs]");
    var tab = tabs ? tabs.querySelector('[data-tab="' + pane.getAttribute("data-tab-pane") + '"]') : null;
    if (tab) activateTab(tabs, tab);
  });

  /* Marquee pause / play control (WCAG 2.2.2) */
  document.addEventListener("click", function (event) {
    var toggle = event.target.closest ? event.target.closest("[data-marquee-toggle]") : null;
    if (!toggle) return;
    var wrap = toggle.closest(".marquee-wrap");
    var track = wrap ? wrap.querySelector("[data-marquee]") : null;
    if (!track) return;
    var paused = !track.classList.contains("is-paused");
    track.classList.toggle("is-paused", paused);
    toggle.setAttribute("aria-pressed", paused ? "true" : "false");
    toggle.setAttribute("aria-label", paused ? toggle.getAttribute("data-label-play") : toggle.getAttribute("data-label-pause"));
    toggle.querySelectorAll("[data-icon-pause]").forEach(function (el) { el.hidden = paused; });
    toggle.querySelectorAll("[data-icon-play]").forEach(function (el) { el.hidden = !paused; });
  });
})();
